
export default {
  name: "cal-dropdown-input",
  data() {
    return {
      isOpen: false,
      height: 0,
    };
  },
  computed: {
    verticalLineTransform() {
      return {
        transform: this.isOpen ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.1s ease",
        transformOrigin: "center",
      };
    },
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  watch: {
    text(){
      this.$emit("onInputChange", this.text);
    }
  },
  mounted(){
    if(this.text && this.text.length > 0){
      this.toggle();
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    handleMessage(event){
      this.$emit("onInputChange", event);
    },
    enter(el) {
      el.style.height = "0px";
      el.offsetHeight;
      el.style.height = el.scrollHeight + "px";
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    leave(el) {
      el.style.height = el.scrollHeight + "px";
      el.offsetHeight;
      el.style.height = "0px";
    },
    afterLeave(el) {
      el.style.height = "0px";
    },
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    text:{
      type: String,
      required: false,
      default: ""
    }
  },
};
